import Vue from 'vue'

export default {
  getMySites: function () {
    let apiDetailPath = '/sites'
    return Vue.http.get(Vue.env.apiPath + apiDetailPath, { headers: {'Authorization': 'Bearer ' + Vue.auth.idToken} })
  }
}



// WEBPACK FOOTER //
// ./src/apis/site.js